export var capitalize = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
//# sourceMappingURL=helpers.js.map